import { forwardRef, type Ref, type SVGProps } from "react";
const IconEditOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29.7 6.58 25.42 2.3a1 1 0 0 0-.71-.3 1 1 0 0 0-.72.3l-21 21a.5.5 0 0 0-.06.1.7.7 0 0 0-.12.17 1 1 0 0 0-.07.19v.11l-.71 5A1 1 0 0 0 3 30h.14l5-.71h.11l.19-.07a.7.7 0 0 0 .17-.12.3.3 0 0 0 .1-.06l16.7-16.7L29.7 8a1 1 0 0 0 0-1.42M7.53 27.32l-3.33.48.48-3.33L20.43 8.72l2.85 2.85zm17.18-17.17-2.86-2.86 2.86-2.85 2.85 2.85z" />
  </svg>
);
const ForwardRef = forwardRef(IconEditOutlineSVG);
ForwardRef.displayName = "IconEditOutline";
export { ForwardRef as IconEditOutline };
